<template>
  <v-container class="vh-footer pd20 lynn-web-in overout bg-gray">
    <div class="web-side"></div>
    <div class="location-box np">
      <div class="web-logo">
        <Weblogo width="55" height="30"/>
      </div>
      <a @click="back()" class="back">
        <Back />
      </a>
      <strong class="lo-title">서비스 사용료 상세</strong>
    </div>
    <v-card
      max-width="750"
      class="mx-auto nops bg-gray"
      style="border-radius: 0"
    >
      <v-card-text class="pd0">
        <!-- 합계 요약 -->
        <div class="servicefee-summary" v-if="items.length">
          <div class="servicefee-summary__top">
            <strong class="servicefee-summary__month">
              {{ month }}월 서비스 사용료
            </strong>
            <strong class="servicefee-summary__total">
              {{ fee.amount | comma }}<span>원</span>
            </strong>
          </div>
          <div class="servicefee-summary__meta">
            <span>
              전월 대비
              <b v-if="fee.diff_to_last_month > 0" class="up"
                >+{{ fee.diff_to_last_month | comma }}원</b
              >
              <b v-else-if="fee.diff_to_last_month < 0" class="down"
                >{{ fee.diff_to_last_month | comma }}원</b
              >
              <b v-else>-</b>
            </span>
            <span>이용 <b>{{ items.length }}건</b></span>
          </div>
        </div>

        <!-- 이용 내역: 한 건을 누르면 상세 팝업 -->
        <div class="servicefee-list" v-if="items.length">
          <button
            v-for="(item, index) in items"
            :key="`${item.facility_name}-${item.use_date}-${index}`"
            type="button"
            class="servicefee-row"
            @click="openDetail(item)"
          >
            <span class="servicefee-row__main">
              <strong class="servicefee-row__name">{{ item.goods_name }}</strong>
              <span class="servicefee-row__meta">
                {{ item.facility_name }}
                <span class="servicefee-row__dot"></span>
                {{ formatDateTime(item.use_date) }}
              </span>
            </span>
            <strong class="servicefee-row__amount"
              >{{ item.amount | comma }}원</strong
            >
            <span class="servicefee-row__arrow"></span>
          </button>
        </div>

        <strong class="t-cont-title text-center mt-10" v-else-if="!loadingBar">
          조회된 서비스 사용료 내역이 없습니다.
        </strong>
      </v-card-text>
    </v-card>

    <!-- 상세 팝업 -->
    <v-dialog v-model="detailDialog" max-width="500">
      <div class="servicefee-popup" v-if="selectedItem">
        <strong class="servicefee-popup__title">이용 상세</strong>

        <div class="servicefee-popup__fields">
          <div class="servicefee-field">
            <div class="servicefee-field__label">시설명</div>
            <div class="servicefee-field__value">
              {{ selectedItem.facility_name || "-" }}
            </div>
          </div>
          <div class="servicefee-field">
            <div class="servicefee-field__label">상품명</div>
            <div class="servicefee-field__value">
              {{ selectedItem.goods_name || "-" }}
            </div>
          </div>
          <div class="servicefee-field">
            <div class="servicefee-field__label">이용일자</div>
            <div class="servicefee-field__value">
              {{ formatDateTime(selectedItem.use_date) }}
            </div>
          </div>
          <div class="servicefee-field">
            <div class="servicefee-field__label">금액</div>
            <div class="servicefee-field__value is-amount">
              {{ selectedItem.amount | comma }}원
            </div>
          </div>
          <div class="servicefee-field">
            <div class="servicefee-field__label">상태</div>
            <div class="servicefee-field__value">
              {{ selectedItem.status || "-" }}
            </div>
          </div>
        </div>

        <button
          type="button"
          class="servicefee-popup__close"
          @click="detailDialog = false"
        >
          닫기
        </button>
      </div>
    </v-dialog>

    <div class="text-center" v-if="loadingBar">
      <v-progress-circular
        fullscreen
        indeterminate
        color="red"
        style="position: fixed; top: calc(50% - 16px); left: calc(50% - 16px)"
      ></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import { getServiceFeeDetail } from "@/api/index";
import Weblogo from "@/assets/images/common/new-logo.svg";
import Back from "@/assets/images/icon/icon-back.svg";
export default {
  name: "ServiceFeeDetail",
  components: {
    Back,
    Weblogo,
  },
  data() {
    return {
      fee: {},
      year: "",
      month: "",
      loadingBar: false,
      detailDialog: false,
      selectedItem: null,
    };
  },
  computed: {
    home() {
      return this.$store.getters.getTenantHome;
    },
    items() {
      return Array.isArray(this.fee.items) ? this.fee.items : [];
    },
  },
  watch: {
    // 뒤로가기 등으로 화면을 벗어나면 팝업을 닫는다.
    $route() {
      this.detailDialog = false;
    },
  },
  methods: {
    getDetail() {
      this.loadingBar = true;
      getServiceFeeDetail(this.home.id, this.year, this.month)
        .then((res) => {
          this.fee = res.data;
          this.loadingBar = false;
        })
        .catch(() => {
          this.fee = {};
          this.loadingBar = false;
          this.$store.commit(
            "ERROR",
            "서비스 사용료 상세내역을 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
          );
        });
    },
    openDetail(item) {
      this.selectedItem = item;
      this.detailDialog = true;
    },
    formatDateTime(value) {
      const digits = String(value || "").replace(/\D/g, "");

      if (!digits) {
        return "-";
      }

      if (digits.length === 8) {
        return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
      }

      if (digits.length >= 12) {
        return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(
          6,
          8
        )} ${digits.slice(8, 10)}:${digits.slice(10, 12)}`;
      }

      return value;
    },
    back() {
      this.$router.push({
        name: "serviceFee",
        params: { year: this.year, month: this.month },
      });
    },
  },
  created() {
    this.year = this.$route.params.year;
    this.month = this.$route.params.month;

    // 조회 월 없이 직접 진입한 경우 목록으로 되돌린다.
    if (!this.year || !this.month) {
      this.$router.replace({ name: "serviceFee" });
      return;
    }

    this.getDetail();
  },
};
</script>

<style scoped>
/* 합계 요약 */
.servicefee-summary {
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 16px 14px 14px;
}

.servicefee-summary__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.servicefee-summary__month {
  color: #232323;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.servicefee-summary__total {
  color: #e66a1f;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

.servicefee-summary__total span {
  font-size: 14px;
}

.servicefee-summary__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e5e5e5;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 500;
}

.servicefee-summary__meta b {
  color: #232323;
  font-weight: 700;
}

.servicefee-summary__meta .up {
  color: #ff6868;
}

.servicefee-summary__meta .down {
  color: #44b3bf;
}

/* 이용 내역 목록 */
.servicefee-list {
  border-radius: 10px;
  background-color: #ffffff;
  overflow: hidden;
}

.servicefee-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
  background-color: #ffffff;
  padding: 13px 14px;
  text-align: left;
  cursor: pointer;
}

.servicefee-row:last-of-type {
  border-bottom: 0;
}

.servicefee-row__main {
  flex: 1 1 auto;
  min-width: 0;
}

.servicefee-row__name {
  display: block;
  color: #232323;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.servicefee-row__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 6px;
  margin-top: 3px;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.servicefee-row__dot {
  flex: 0 0 auto;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: #b8b8b8;
}

.servicefee-row__amount {
  flex: 0 0 auto;
  color: #232323;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

.servicefee-row__arrow {
  flex: 0 0 auto;
  width: 7px;
  height: 7px;
  border-top: 2px solid #b8b8b8;
  border-right: 2px solid #b8b8b8;
  transform: rotate(45deg);
}

/* 상세 팝업 */
.servicefee-popup {
  border-radius: 20px;
  background-color: #ffffff;
  padding: 28px 24px 22px;
  text-align: left;
}

.servicefee-popup__title {
  display: block;
  margin-bottom: 22px;
  text-align: center;
  color: #e66a1f;
  font-size: 24px;
  font-weight: 700;
}

.servicefee-field + .servicefee-field {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e5e5e5;
}

.servicefee-field__label {
  color: #b8b8b8;
  font-size: 13px;
  font-weight: 700;
}

.servicefee-field__value {
  color: #232323;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  word-break: keep-all;
}

.servicefee-field__value.is-amount {
  color: #ef761d;
  font-weight: 700;
}

.servicefee-popup__close {
  width: 100%;
  height: 40px;
  margin-top: 22px;
  border: 0;
  border-radius: 999px;
  background-color: #d9d9d9;
  color: #232323;
  font-size: 14px;
  font-weight: 700;
}

@media (min-width: 601px) {
  .servicefee-field {
    display: flex;
    align-items: baseline;
    gap: 12px;
  }

  .servicefee-field__label {
    flex: 0 0 90px;
  }
}

@media (max-width: 600px) {
  .servicefee-field__label {
    margin-bottom: 3px;
  }
}
</style>
